import {create, StoreApi, UseBoundStore} from "zustand";

export interface PcbStackupEditorDialogStore {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}
export type UsePcbStackupEditorDialogStore = UseBoundStore<StoreApi<PcbStackupEditorDialogStore>>;

export function createPcbStackupEditorDialogStore() {
    return create<PcbStackupEditorDialogStore>((set) => ({
        isOpen: false,
        open: () => set({isOpen: true}),
        close: () => set({isOpen: false}),
    }));
}
